import { render, staticRenderFns } from "./DropdownTippy.vue?vue&type=template&id=c1036110"
import script from "./DropdownTippy.vue?vue&type=script&lang=js"
export * from "./DropdownTippy.vue?vue&type=script&lang=js"
import style0 from "./DropdownTippy.vue?vue&type=style&index=0&id=c1036110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports